import { getFichaMedicaCatalogosExtrasSync } from '../../data/consultorioData';

const ALERGIA_OPCIONES = [
  { id: 'medicamentos', label: 'Medicamentos' },
  { id: 'alimentos', label: 'Alimentos' },
  { id: 'latex', label: 'Látex' },
  { id: 'otros', label: 'Otros' },
];

const ENF_CRONICA_OPCIONES = [
  { id: 'diabetes', label: 'Diabetes' },
  { id: 'hipertension', label: 'Hipertensión arterial' },
  { id: 'hipertiroidismo', label: 'Hipertiroidismo' },
  { id: 'hipotiroidismo', label: 'Hipotiroidismo' },
  { id: 'vih', label: 'VIH' },
  { id: 'covid', label: 'COVID / Secuelas (long COVID)' },
  { id: 'cardiopatia', label: 'Cardiopatía' },
  { id: 'asma', label: 'Asma' },
  { id: 'epoc', label: 'EPOC / Enfermedad pulmonar obstructiva crónica' },
  { id: 'insuf_renal', label: 'Insuficiencia renal crónica' },
  { id: 'hepatopatia', label: 'Enfermedad hepática crónica' },
  { id: 'epilepsia', label: 'Epilepsia' },
  { id: 'artritis', label: 'Artritis / artrosis relevante' },
  { id: 'osteoporosis', label: 'Osteoporosis' },
  { id: 'autoinmune', label: 'Enfermedad autoinmune / reumatológica' },
  { id: 'enf_otros', label: 'Otros' },
];

const HABITO_OPCIONES = [
  { id: 'tabaco', label: 'Tabaco' },
  { id: 'alcohol', label: 'Alcohol' },
  { id: 'drogas', label: 'Drogas' },
  { id: 'bruxismo', label: 'Bruxismo' },
  { id: 'resp_bucal', label: 'Respiración bucal' },
  { id: 'onicofagia', label: 'Onicofagia' },
  { id: 'succion_digital', label: 'Succión digital / hábitos orales infantiles' },
  { id: 'deglucion_atipica', label: 'Deglución atípica' },
  { id: 'apnea_roncar', label: 'Ronquidos / apnea del sueño' },
  { id: 'snacking', label: 'Picoteo / consumo frecuente azúcar' },
];

const SIGNOS_ODONTO_BASE_ROWS = [
  { key: 'presionArterial', label: 'Presión arterial' },
  { key: 'frecuenciaCardiacaSignos', label: 'Frecuencia cardíaca' },
  { key: 'temperatura', label: 'Temperatura' },
  { key: 'saturacionOxigeno', label: 'Saturación de oxígeno (SpO₂ / %)' },
];

export const ANTECEDENTES_ODONTO_TABLA_BASE = [
  { key: 'alergiaAntibiotico', label: 'Alergia antibióticos', detailPh: '¿A cuál? Ej. penicilina, amoxicilina…' },
  { key: 'alergiaAnestesia', label: 'Alergia anestesia', detailPh: 'Ej. lidocaína, articaina…' },
  { key: 'diabetes', label: 'Diabetes', detailPh: 'Ej. tipo 1/2, tiempo de diagnóstico, tratamiento…' },
  { key: 'antecedentesCancer', label: 'Cáncer', detailPh: 'Tipo, año de diagnóstico o tratamiento…' },
  { key: 'hipertension', label: 'Hipertensión', detailPh: 'Ej. controlada con medicación, valores…' },
  { key: 'hemorragias', label: 'Hemorragias', detailPh: 'Ej. tras extracción, anticoagulantes…' },
  { key: 'tuberculosis', label: 'Tuberculosis', detailPh: 'Ej. año, tratamiento completado…' },
  { key: 'asma', label: 'Asma', detailPh: 'Ej. bronquial, uso de inhalador…' },
  { key: 'antecedentesCardiopatia', label: 'Enfermedades cardíacas', detailPh: 'Ej. soplo, marcapasos, anticoagulación…' },
];

const ANTECEDENTE_DETALLE_PH_DEFAULT = 'Describa brevemente…';

export function formatAntecedenteOdontoValor(refiere, detalle) {
  const r = (refiere || '').trim();
  const d = (detalle || '').trim();
  if (r === 'Sí' && d) return `Sí — ${d}`;
  if (r === 'Sí') return 'Sí (pendiente de especificar)';
  return r;
}

/** Etiquetas de ítems con «Sí» pero sin texto de detalle (validación al guardar). */
export function getAntecedentesOdontoDetallesFaltantes(form, idDoctor) {
  const detalles = ensureObj(form.antecedentesOdontoDetalles);
  const faltantes = [];
  for (const { key, label } of ANTECEDENTES_ODONTO_TABLA_BASE) {
    if (form[key] === 'Sí' && !(detalles[key] || '').trim()) faltantes.push(label);
  }
  for (const ex of mergeOdontoAntecedentesExtras(idDoctor)) {
    if (ensureObj(form.antecedentesOdontoExtrasValores)[ex.id] === 'Sí' && !(detalles[ex.id] || '').trim()) {
      faltantes.push(ex.label);
    }
  }
  return faltantes;
}

export const EXAMEN_ESTOMATOGNATICO_TABLA_BASE = [
  { key: 'examenLabios', label: 'Labios' },
  { key: 'examenMejillas', label: 'Mejillas' },
  { key: 'examenMaxilarSuperior', label: 'Maxilar superior' },
  { key: 'examenMaxilarInferior', label: 'Maxilar inferior' },
  { key: 'examenLengua', label: 'Lengua' },
  { key: 'examenPaladar', label: 'Paladar' },
  { key: 'examenPiso', label: 'Piso de boca' },
  { key: 'examenCarrillos', label: 'Carrillos' },
  { key: 'examenGlandulasSalivales', label: 'Glándulas salivales' },
  { key: 'examenATM', label: 'ATM' },
  { key: 'examenGanglios', label: 'Ganglios linfáticos' },
];

export function formatExamenEstomaValor(marcado, detalle) {
  const d = (detalle || '').trim();
  if (!marcado) return d ? d : '';
  return d ? `Hallazgo — ${d}` : 'Hallazgo (sin describir)';
}

/** Migra texto legacy en `examenLabios`, etc. → marcas + detalles. */
export function migrateExamenEstomatognaticoForm(merged) {
  merged.examenEstomatognaticoMarcas = ensureObj(merged.examenEstomatognaticoMarcas);
  merged.examenEstomatognaticoDetalles = ensureObj(merged.examenEstomatognaticoDetalles);
  merged.examenOdontoExtrasMarcas = ensureObj(merged.examenOdontoExtrasMarcas);
  const exVal = ensureObj(merged.examenOdontoExtrasValores);

  for (const { key } of EXAMEN_ESTOMATOGNATICO_TABLA_BASE) {
    const legacy = (merged[key] || '').trim();
    const det = (merged.examenEstomatognaticoDetalles[key] || '').trim();
    if (legacy && !det) {
      merged.examenEstomatognaticoDetalles[key] = legacy;
      merged.examenEstomatognaticoMarcas[key] = true;
    }
    merged[key] = merged.examenEstomatognaticoMarcas[key] ? (merged.examenEstomatognaticoDetalles[key] || '').trim() : '';
  }

  for (const [id, txt] of Object.entries(exVal)) {
    const t = (txt || '').trim();
    if (t && !merged.examenOdontoExtrasMarcas[id]) {
      merged.examenOdontoExtrasMarcas[id] = true;
    }
    if (!merged.examenOdontoExtrasMarcas[id]) exVal[id] = '';
  }
  merged.examenOdontoExtrasValores = exVal;
  return merged;
}

function ensureArr(val) {
  return Array.isArray(val) ? val.filter((x) => x != null && x !== '') : [];
}

function ensureObj(val) {
  return val && typeof val === 'object' && !Array.isArray(val) ? val : {};
}

function mergeAlergiaTiposLista(idDoctor) {
  const ex = getFichaMedicaCatalogosExtrasSync(idDoctor).alergiasTiposExtras.map((e) => ({ id: e.id, label: e.label }));
  return [...ALERGIA_OPCIONES, ...ex];
}

function mergeEnfermedadesCronicasLista(idDoctor) {
  const base = ENF_CRONICA_OPCIONES.filter((o) => o.id !== 'enf_otros');
  const ex = getFichaMedicaCatalogosExtrasSync(idDoctor).enfermedadesCronicasExtras.map((e) => ({ id: e.id, label: e.label }));
  return [...base, ...ex];
}

function mergeHabitosLista(idDoctor) {
  const ex = getFichaMedicaCatalogosExtrasSync(idDoctor).habitosExtras.map((e) => ({ id: e.id, label: e.label }));
  return [...HABITO_OPCIONES, ...ex];
}

function mergeOdontoAntecedentesExtras(idDoctor) {
  return getFichaMedicaCatalogosExtrasSync(idDoctor).antecedentesOdontoExtras.map((e) => ({ id: e.id, label: e.label }));
}

function mergeExamenEstomaExtras(idDoctor) {
  return getFichaMedicaCatalogosExtrasSync(idDoctor).examenEstomatognaticoExtras.map((e) => ({ id: e.id, label: e.label }));
}

function mergeSignosVitalesOdontoExtras(idDoctor) {
  return getFichaMedicaCatalogosExtrasSync(idDoctor).signosVitalesOpcionesExtras.map((e) => ({ id: e.id, label: e.label }));
}

export function resumenAlergiasLectura(form, idDoctor) {
  const alOps = mergeAlergiaTiposLista(idDoctor);
  const alTip = ensureArr(form.alergiasTipos);
  const catPart = alTip.map((tid) => alOps.find((o) => o.id === tid)?.label).filter(Boolean).join(', ');
  const esp = (form.alergiasEspecificacion || '').trim();
  return [catPart && `Tipos: ${catPart}`, esp].filter(Boolean).join('. ').trim() || (form.alergias || '').trim();
}

export function resumenEnfermedadesLectura(form, idDoctor) {
  const enfOpsMain = mergeEnfermedadesCronicasLista(idDoctor);
  const enfSel = ensureArr(form.enfermedadesCronicasSeleccion);
  const enfOtroTxt = (form.enfermedadesCronicasOtro || '').trim();
  const partes = enfSel
    .filter((eid) => eid !== 'enf_otros')
    .map((eid) => enfOpsMain.find((o) => o.id === eid)?.label)
    .filter(Boolean);
  if (enfOtroTxt) partes.push(`Otros: ${enfOtroTxt}`);
  return partes.length ? partes.join(' · ') : (form.enfermedadesCronicas || '').trim();
}

export function resumenHabitosLectura(form, idDoctor) {
  const hSel = ensureArr(form.habitosSeleccion);
  if (!hSel.length) {
    const leg = [
      (form.habitosFumar || '').trim() && `Tabaco: ${form.habitosFumar}`,
      (form.habitosAlcohol || '').trim() && `Alcohol: ${form.habitosAlcohol}`,
      (form.habitosDrogas || '').trim() && `Otros: ${form.habitosDrogas}`,
    ].filter(Boolean);
    return leg.join(' · ');
  }
  const habOps = mergeHabitosLista(idDoctor);
  return habOps.filter((o) => hSel.includes(o.id)).map((o) => o.label).join(', ');
}

export function getSignosVitalesPairs(form, idDoctor) {
  return [
    ...SIGNOS_ODONTO_BASE_ROWS.map((r) => ({ k: r.key, label: r.label, value: form[r.key] })),
    ...mergeSignosVitalesOdontoExtras(idDoctor).map((ex) => ({
      k: `sv_${ex.id}`,
      label: ex.label,
      value: ensureObj(form.signosVitalesExtrasValores)[ex.id],
    })),
  ];
}

export function getAntecedentesOdontoPairs(form, idDoctor) {
  const detalles = ensureObj(form.antecedentesOdontoDetalles);
  return [
    ...ANTECEDENTES_ODONTO_TABLA_BASE.map((r) => ({
      k: r.key,
      label: r.label,
      value: formatAntecedenteOdontoValor(form[r.key], detalles[r.key]),
    })),
    ...mergeOdontoAntecedentesExtras(idDoctor).map((ex) => ({
      k: `ap_${ex.id}`,
      label: ex.label,
      value: formatAntecedenteOdontoValor(
        ensureObj(form.antecedentesOdontoExtrasValores)[ex.id],
        detalles[ex.id]
      ),
    })),
    { k: 'otros_ant', label: 'Otro', value: form.otrosAntecedentes },
  ];
}

export function getExamenEstomaPairs(form, idDoctor) {
  const marcas = ensureObj(form.examenEstomatognaticoMarcas);
  const detalles = ensureObj(form.examenEstomatognaticoDetalles);
  const exMarcas = ensureObj(form.examenOdontoExtrasMarcas);
  const exVal = ensureObj(form.examenOdontoExtrasValores);
  return [
    ...EXAMEN_ESTOMATOGNATICO_TABLA_BASE.map((r) => ({
      k: r.key,
      label: r.label,
      value: formatExamenEstomaValor(marcas[r.key], detalles[r.key] || form[r.key]),
    })),
    ...mergeExamenEstomaExtras(idDoctor).map((ex) => ({
      k: `ex_${ex.id}`,
      label: ex.label,
      value: formatExamenEstomaValor(exMarcas[ex.id], exVal[ex.id]),
    })),
  ];
}
